// extracted by mini-css-extract-plugin
export default {"category-card":"_eowq3","categoryCard":"_eowq3"};